export default {
    sms_system_create_title: "Create SMS System",
    sms_system_edit_title: "Edit SMS System",
    sms_system_create_success_message: "The SMS System has been created",
    sms_system_edit_success_message: "The SMS System has been edited",
    sms_system_same_name_exits: "A SMS System with same name exists already",
    sms_system_same_name_exits_edit: "An Sms integration with the same name or priority already exists",
    sms_system_name: "Name",
    sms_system_display_name: "Display Name",
    sms_system_priority: "Priority",
    sms_system_is_smpp: "Is SMPP",
    sms_system_status: "Status",
}